<template>
  <div class="ws-state-date" @click="$_onDatepickerWrapperClick">
    <Datepicker
      ref="datepicker"
      :class="['date-picker', { 'is-disabled': _disabled }]"
      :value="value"
      @input="$_onInput($event)"
      @closed="datepickerOpenUpward = false"
      :format="customFormatter"
      typeable
      :disabledDates="_disabledDates"
      :placeholder="placeholder"
      :calendar-class="_datepickerCalendarClass"
      input-class="input"
      :disabled="_disabled"
    >
      <template slot="afterDateInput">
        <v-icon size="20" class="icon">mdi-calendar</v-icon>
      </template>
    </Datepicker>
  </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker';
import { shouldOpenDropdownUpward } from '@/helpers/dropdownViewportFlip';
export default {
  data() {
    return {
      datepickerOpenUpward: false,
    };
  },
  props: {
    clearable: {
      type: Boolean,
      default: true,
    },
    value: {},
    placeholder: {
      type: String,
      default: '選擇日期',
    },
    format: {
      type: String,
      default: 'YYYY-MM-DD',
    },
    originData: {
      type: Object,
    },
    getFromDate: {
      type: Function,
    },
    getEndDate: {
      type: Function,
    },
    requiredField: {
      type: String,
      default: null,
    },
    requiredFieldValue: {
      type: String,
    },
  },
  methods: {
    $_onDatepickerWrapperClick() {
      this.$nextTick(() => {
        const dp = this.$refs.datepicker;
        if (!dp || !dp.isOpen) {
          this.datepickerOpenUpward = false;
          return;
        }
        const el = dp.$el;
        if (!el || typeof el.getBoundingClientRect !== 'function') return;
        const rect = el.getBoundingClientRect();
        this.datepickerOpenUpward = shouldOpenDropdownUpward(
          { top: rect.top, bottom: rect.bottom },
          {
            estimatedDropdownHeight: 340,
            viewportHeight: typeof window !== 'undefined' ? window.innerHeight : 0,
          },
        );
      });
    },
    customFormatter(date) {
      return this.$moment(date).format(this.format);
    },
    $_onInput($event) {
      if ($event === null) return;
      this.$emit('input', this.$moment($event).format('YYYY-MM-DD'));
    },
  },
  computed: {
    _datepickerCalendarClass() {
      return ['calendar', { 'calendar--open-up': this.datepickerOpenUpward }];
    },
    _getFromDate() {
      if (this.getFromDate && this.originData) {
        return new Date(this.getFromDate(this.originData));
        // return this.getFromDate(this.originData);
      } else {
        return '';
      }
    },
    _getEndDate() {
      if (this.getEndDate && this.originData) {
        return new Date(this.getEndDate(this.originData));
        // return this.getEndDate(this.originData);
      } else {
        return '';
      }
    },
    _disabledDates() {
      if (this._getFromDate) {
        return {
          to: this._getFromDate,
        };
      } else if (this._getEndDate) {
        return {
          from: this._getEndDate,
        };
      } else {
        return {};
      }
    },
    _disabled() {
      if (this.originData && this.requiredField && this.requiredFieldValue) {
        if (this.originData[this.requiredField] === this.requiredFieldValue) {
          return false;
        } else {
          return true;
        }
      } else {
        return false;
      }
    },
  },
  components: {
    Datepicker,
  },
};
</script>

<style lang="scss">
@import '../assets/scss/ws-state-date.scss';
</style>
